<template>
  <b-card no-body>
    <b-card-header>
      <span class="h5">
        REGRAS DE ACESSO -
        <b-badge variant="warning">{{operacao}}</b-badge>
      </span>
    </b-card-header>
    <b-card-body>
      <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
      <div>
        <b-row>
          <b-col sm="5">
            <b-form-group>
              <label for="codRegraAcesso">Código</label>
              <b-form-input
                type="text"
                id="codRegraAcesso"
                placeholder="Digite o código da regra de acesso"
                v-model="regraAcessoDto.codRegraAcesso"
                @input="$v.regraAcessoDto.codRegraAcesso.$touch()"
                :state="$v.regraAcessoDto.codRegraAcesso.$error ? false : null"
                :disabled="desabilitarFormulario"
              ></b-form-input>
              <b-form-invalid-feedback>O código da regra de acesso é obrigatório</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col sm="7">
            <b-form-group>
              <label for="descricaoRegraAcesso">Descrição</label>
              <b-form-input
                type="text"
                id="descricaoRegraAcesso"
                placeholder="Digite a descrição da regra de acesso"
                v-model="regraAcessoDto.descricaoRegraAcesso"
                @input="$v.regraAcessoDto.descricaoRegraAcesso.$touch()"
                :state="$v.regraAcessoDto.descricaoRegraAcesso.$error ? false : null"
                :disabled="desabilitarFormulario"
              ></b-form-input>
              <b-form-invalid-feedback>A descrição da regra de acesso é obrigatória</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-card-body>
    <b-card-footer>
      <b-button
        variant="primary"
        @click.stop="salvarForm()"
        :disabled="!habilitarSalvar"
        v-if="mostraBtnSalvarCancelar"
        class="mr-2"
      >
        <i class="fa fa-save"></i> Salvar
      </b-button>
      <b-button
        variant="primary"
        v-if="mostraBtnAtualizar"
        @click.stop="transfereParaAtualizacao()"
        class="mr-2"
      >
        <i class="fa fa-edit"></i> Atualizar
      </b-button>
      <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
        <span v-if="mostraBtnSalvarCancelar">
          <i class="fa fa-remove"></i> Cancelar
        </span>
        <span v-if="!mostraBtnSalvarCancelar">
          <i class="fa fa-history"></i> Voltar
        </span>
      </b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import RegrasAcessoServicos from "./RegrasAcessoServicos";

export default {
  data() {
    return {
      operacao: "",
      erros: [],
      regraAcessoDto: {
        regraAcessoId: "",
        codRegraAcesso: "",
        descricaoRegraAcesso: ""
      }
    };
  },
  methods: {
    salvarForm() {
      let regraAcesso = {
        CodRegraAcesso: this.regraAcessoDto.codRegraAcesso.toUpperCase(),
        DescricaoRegraAcesso: this.regraAcessoDto.descricaoRegraAcesso.toUpperCase()
      };
      if (this.operacao === "INSERIR") {
        this.inserirRegraAcesso(regraAcesso);
      } else {
        regraAcesso.RegraAcessoId = this.regraAcessoDto.regraAcessoId;
        this.atualizarRegraAcesso(regraAcesso);
      }
    },

    cancelar() {
      this.erros = [];
      if (this.operacao === "ATUALIZAR") {
        this.$router.push({
          name: "RegrasAcesso_Detalhar",
          params: {
            id: this.$route.params.id
          }
        });
      } else {
        this.$router.push({ name: "RegrasAcesso", query: this.$route.query });
      }
    },

    inserirRegraAcesso(regraAcesso) {
      this.$store.dispatch("addRequest");
      RegrasAcessoServicos.inserirRegraAcesso(regraAcesso).then(response => {
        if (response) {
          if (response.success) {
            this.registroSalvoComSucesso(response.data);
          } else {
            this.erros = response.errors;
          }
        }
        this.$store.dispatch("removeRequest");
      });
    },

    obterRegraAcesso(id) {
      this.$store.dispatch("addRequest");
      RegrasAcessoServicos.obterPorId(this.$route.params.id).then(response => {
        if (response) {
          if (response.success) {
            this.preencheFormulario(response.data);
          } else {
            this.erros = response.errors;
          }
        }
        this.$store.dispatch("removeRequest");
      });
    },

    atualizarRegraAcesso(regraAcesso) {
      this.$store.dispatch("addRequest");
      RegrasAcessoServicos.atualizarRegraAcesso(regraAcesso).then(response => {
        if (response) {
          if (response.success) {
            this.registroSalvoComSucesso(regraAcesso.RegraAcessoId);
          } else {
            this.erros = response.errors;
          }
        }
        this.$store.dispatch("removeRequest");
      });
    },

    registroSalvoComSucesso(data) {
      this.erros = [];
      this.$toast.success(
        "Registro salvo com sucesso!",
        "OK",
        this.$toastConfig.success
      );
      this.$store.dispatch("setRecarregar", true);
      this.$router.push({
        name: "RegrasAcesso_Detalhar",
        params: { id: data }
      });
    },

    preencheFormulario(data) {
      this.regraAcessoDto.regraAcessoId = data.regraAcessoId;
      this.regraAcessoDto.codRegraAcesso = data.codRegraAcesso;
      this.regraAcessoDto.descricaoRegraAcesso = data.descricaoRegraAcesso;
    },

    transfereParaAtualizacao() {
      this.$router.push({
        name: "RegrasAcesso_Atualizar",
        params: { id: this.$route.params.id }
      });
    },

    processarRota(rota) {
      if (rota.name === "RegrasAcesso_Inserir") {
        this.operacao = "INSERIR";
      } else if (rota.name === "RegrasAcesso_Detalhar") {
        this.operacao = "DETALHAR";
        this.obterRegraAcesso();
      } else if (rota.name === "RegrasAcesso_Atualizar") {
        this.operacao = "ATUALIZAR";
        this.obterRegraAcesso();
      }
    }
  },

  computed: {
    habilitarSalvar() {
      return !this.$v.$invalid;
    },

    desabilitarFormulario() {
      return this.operacao === "DETALHAR";
    },

    mostraBtnSalvarCancelar() {
      return (
        (this.operacao === "INSERIR" || this.operacao === "ATUALIZAR") &&
        (this.$temAcessoView("CTRLACS-RA-01") ||
          this.$temAcessoView("CTRLACS-RA-03"))
      );
    },

    mostraBtnAtualizar() {
      return (
        !this.mostraBtnSalvarCancelar && this.$temAcessoView("CTRLACS-RA-03")
      );
    }
  },

  created() {
    this.processarRota(this.$route);
  },

  watch: {
    $route(to, from) {
      this.processarRota(to);
    }
  },

  validations: {
    regraAcessoDto: {
      codRegraAcesso: {
        required
      },
      descricaoRegraAcesso: {
        required
      }
    }
  }
};
</script>
